export enum AlertStatesEnum {
  publicChat = 'publicChat',
  chatPersonAlert = 'chatPersonAlert',
  startChatAlert = 'startChatAlert',
  supportChat = 'supportChat',
  businessChat = 'businessChat',
  somethingWentWrong = 'somethingWentWrong',
  translatorAlert = 'translatorAlert',
  walletAlert = 'walletAlert',
}
